import React from "react";
import '../css/Style.css';
function Faq(){
    return(<>
      <div className="container mt-5 mb-5">
        <div className="row">
          <div className="qsn bg-secondary text-start rounded mb-3">
          <h3 className="fw-blod bg_text p-2">Q1: What types of fruits do you offer at your shop?</h3>
            <p className="text-muted p-2">A1: We offer a diverse range of fresh and seasonal fruits, including apples, bananas, oranges, mangoes, guavas, and more. Our selection may vary based on seasonal availability.</p>
          </div>
          <div className="qsn bg-secondary text-start rounded mb-3">
          <h3 className="fw-blod bg_text p-2">Q2: Are your fruits locally sourced?</h3>
            <p className="text-muted p-2">A1: We offer a diverse range of fresh and seasonal fruits, including apples, bananas, oranges, mangoes, guavas, and more. Our selection may vary based on seasonal availability.</p>
          </div>
          <div className="qsn bg-secondary text-start rounded mb-3">
          <h3 className="fw-blod bg_text p-2">Q3: Do you offer organic fruits?</h3>
            <p className="text-muted p-2">A4: We take pride in maintaining the freshness of our fruits. Our inventory is regularly replenished, and we follow proper storage and handling practices to ensure quality.</p>
          </div>

          <div className="qsn bg-secondary text-start rounded mb-3">
          <h3 className="fw-blod bg_text p-2">Q4: How do you ensure the freshness of your fruits?</h3>
            <p className="text-muted p-2">A3: Yes, we have a selection of organic fruits. They are sourced from certified organic farms, providing you with a healthy and environmentally friendly option.</p>
          </div>

          <div className="qsn bg-secondary text-start rounded mb-3">
          <h3 className="fw-blod bg_text p-2">Q5: Can I request a fruit basket or custom fruit arrangement for special occasions?</h3>
            <p className="text-muted p-2">A5: Absolutely! We offer fruit baskets and custom arrangements for special occasions. Feel free to discuss your preferences with our staff, and we'll be happy to assist you.</p>
          </div>

          <div className="qsn bg-secondary text-start rounded mb-3">
          <h3 className="fw-blod bg_text p-2">Q6: Are there any discounts or loyalty programs available?</h3>
            <p className="text-muted p-2">A6: Yes, we often have promotions and discounts on various fruits. Additionally, we offer a loyalty program to our regular customers for exclusive benefits. Ask our staff for more details.</p>
          </div>
          <div className="qsn bg-secondary text-start rounded mb-3">
          <h3 className="fw-blod bg_text p-2">Q7: Can I request a fruit basket or custom fruit arrangement for special occasions?</h3>
            <p className="text-muted p-2">A5: Absolutely! We offer fruit baskets and custom arrangements for special occasions. Feel free to discuss your preferences with our staff, and we'll be happy to assist you.</p>
          </div>
        </div> 

      </div>
    </>);
}

export default Faq;